import { render, staticRenderFns } from "./OrdCuardroComparativo.vue?vue&type=template&id=15c40c47&"
import script from "./OrdCuardroComparativo.vue?vue&type=script&lang=js&"
export * from "./OrdCuardroComparativo.vue?vue&type=script&lang=js&"
import style0 from "./OrdCuardroComparativo.vue?vue&type=style&index=0&id=15c40c47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports